module.exports = __webpack_public_path__ + "img/20200721-1.05b25ba9.png";